var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.marginRight,attrs:{"icon":"","x-large":"","color":"primary"},on:{"click":function($event){return _vm.openLink()}}},[_c('v-icon',{attrs:{"large":"","color":"primary"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }